import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const { FiPhone, FiMail, FiMapPin, FiClock, FiStar, FiCheck } = FiIcons;
const { FaWhatsapp } = FaIcons;

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-950 text-white border-t border-gray-800">
      <div className="bg-blue-600 py-6">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="flex items-center space-x-3 mb-4 md:mb-0">
              <SafeIcon icon={FiPhone} className="text-3xl animate-pulse" />
              <span className="text-2xl font-extrabold tracking-tight">Manchester 24/7 Support</span>
            </div>
            <div className="flex flex-wrap justify-center gap-4">
              <a href="tel:+447459014304" className="bg-white text-blue-600 px-8 py-3 rounded-xl font-black text-xl hover:bg-gray-100 transition-all shadow-lg">
                07459 014304
              </a>
              <a href="https://wa.me/447459014304" target="_blank" rel="noopener noreferrer" className="bg-[#25D366] text-white px-8 py-3 rounded-xl font-black text-xl hover:bg-[#128c7e] transition-all shadow-lg flex items-center space-x-2">
                <SafeIcon icon={FaWhatsapp} />
                <span>WhatsApp</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="py-20">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-12 text-left">
            <div className="lg:col-span-1">
              <div className="flex items-center space-x-3 mb-8">
                <img src="https://i.postimg.cc/59sGRNrb/LLOGO.png" alt="ALVI GROUP LTD" className="h-12 w-auto" />
                <h3 className="text-2xl font-bold tracking-tight">ALVI GROUP</h3>
              </div>
              <p className="text-gray-400 text-lg mb-8 leading-relaxed">
                Expert local drainage services covering Manchester and surrounding areas - family-run since 2009.
              </p>
              <div className="flex items-center space-x-2 text-yellow-400 text-xl">
                {[...Array(5)].map((_, i) => <SafeIcon key={i} icon={FiStar} className="fill-current" />)}
              </div>
            </div>

            <div>
              <h4 className="text-xl font-bold mb-8 text-blue-500 uppercase tracking-widest">Quick Links</h4>
              <ul className="space-y-4 text-gray-400 text-lg">
                <li><button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors">Our Services</button></li>
                <li><button onClick={() => scrollToSection('about')} className="hover:text-white transition-colors">About Us</button></li>
                <li><button onClick={() => scrollToSection('testimonials')} className="hover:text-white transition-colors">Reviews</button></li>
                <li><button onClick={() => scrollToSection('gallery')} className="hover:text-white transition-colors">Our Work</button></li>
              </ul>
            </div>

            <div>
              <h4 className="text-xl font-bold mb-8 text-blue-500 uppercase tracking-widest">Why Choose Us</h4>
              <div className="space-y-4">
                {[ "Fixed Fee Pricing", "No Hidden Costs", "Same-Day Response", "Local Manchester Team" ].map((item, i) => (
                  <div key={i} className="flex items-center space-x-2 text-gray-400">
                    <SafeIcon icon={FiCheck} className="text-green-500" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-xl font-bold mb-8 text-blue-500 uppercase tracking-widest">Connect</h4>
              <div className="space-y-6">
                <div className="flex items-start space-x-3">
                  <SafeIcon icon={FiMapPin} className="text-blue-500 mt-1" />
                  <span className="text-gray-300">Manchester, UK</span>
                </div>
                <div className="flex items-start space-x-3">
                  <SafeIcon icon={FiPhone} className="text-blue-500 mt-1" />
                  <span className="text-gray-300">07459 014304</span>
                </div>
                <div className="flex items-start space-x-3">
                  <SafeIcon icon={FaWhatsapp} className="text-blue-500 mt-1" />
                  <span className="text-gray-300">+44 7459 014304</span>
                </div>
                <div className="flex items-start space-x-3">
                  <SafeIcon icon={FiMail} className="text-blue-500 mt-1" />
                  <span className="text-gray-300">info@alvigroupltd.co.uk</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-900 py-10 bg-black">
        <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center text-gray-500 text-sm">
          <p>© 2024 ALVI GROUP LTD. Family-run since 2009. Professional Drainage Solutions.</p>
          <div className="flex space-x-8 mt-4 md:mt-0">
            <span>Privacy Policy</span>
            <span>Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;